import { Build, Component, Element, Host, Prop, Watch, h } from '@stencil/core';
import { uniqueId } from '../../helpers/helpers';
import type { AccordionData } from '../../helpers/utils/accordion-types';
@Component({
  tag: 'cms-accordion',
  styleUrl: 'cms-accordion.scss',
  shadow: true,
})
export class CmsAccordion {
  private accordionData: AccordionData[] = [];

  /**
   * Set Accordion Layout full 100% or two-thirds 66%
   */
  @Prop() layout: 'full' | 'two-thirds' = 'two-thirds';

  /**
   * Set Accordion Items Content
   */
  @Prop() accordionItems: AccordionData | string;

  /**
   * set the first item is open
   */
  @Prop() firstItemIsOpen: boolean;

  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  @Element() accordion: HTMLElement;

  @Watch('accordionItems')
  private accordionItemsWatcher(newValue: AccordionData | string) {
    if (!newValue) return;
    this.accordionData =
      typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
  }

  private renderAccordionRow() {
    if (!this.accordionData) return;
    return this.accordionData.map((item: AccordionData, index: number) => {
      const rowId = uniqueId();
      const isFirstItemOpen =
        index === 0 ? this.firstItemIsOpen === true : false;

      return (
        <cms-accordion-row
          contentData={item}
          firstItemIsOpen={isFirstItemOpen}
          key={rowId}
        />
      );
    });
  }

  connectedCallback() {
    if (!this.accordionItems) return;
    this.accordionItemsWatcher(this.accordionItems);
  }

  componentDidLoad() {
    this.accordion.style.opacity = Build.isBrowser ? '1' : '0';
  }

  render() {
    return (
      <Host>
        <section class='accordion-group' aria-label={this.accessibleName}>
          <div class='accordion-group-inner'>{this.renderAccordionRow()}</div>
        </section>
      </Host>
    );
  }
}
